import React from 'react';

import { Nav } from './link-styled-component';

const LinkA = props => {
  return <Nav {...props}>{props.children}</Nav>;
};

export default LinkA;
